<template>
  <div class="elite-tabs-wrapper-content">
    <div class="title-header">
      <div class="row">
        <div class="col-6">
          <h3>{{ taxGroup.name }}</h3>
        </div>

        <div class="col-6 text-right">
          <base-button
            class="elite-button btn-outline-danger"
            icon
            size="sm"
            v-if="$currentUserCan($permissions.PERM_DELETE_TAXES)"
            @click="deleteTaxGroup"
          >
            <span class="btn-inner--icon">
              <i class="far fa-trash-alt"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("COMMON.DELETE") }}
            </span>
          </base-button>

          <base-button
            class="elite-button add"
            icon
            size="sm"
            v-if="$currentUserCan($permissions.PERM_EDIT_TAXES)"
            @click="editTaxGroup"
          >
            <span class="btn-inner--icon">
              <i class="far fa-edit"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("COMMON.EDIT") }}
            </span>
          </base-button>
        </div>
      </div>
    </div>

    <div class="all-infos">
      <div class="all-infos-text">
        <dl class="row" v-if="taxGroup.organization">
          <dt>{{ $t("COMMON.ORGANIZATION") }}</dt>
          <dd>
            {{ taxGroup.organization.name ?? "" }}
          </dd>
        </dl>

        <dl class="row" v-if="taxGroup.name">
          <dt>{{ $t("COMMON.NAME") }}</dt>
          <dd>
            {{ taxGroup.name ?? "" }}
          </dd>
        </dl>

        <dl class="row" v-if="taxGroup.country_code">
          <dt>{{ $t("TAXES.COUNTRY_CODE") }}</dt>
          <dd>
            {{ taxGroup.country_code ?? "" }}
          </dd>
        </dl>

        <dl class="row" v-if="taxGroup.excerpt">
          <dt>{{ $t("COMMON.EXCERPT") }}</dt>
          <dd>
            {{ taxGroup.excerpt ?? "" }}
          </dd>
        </dl>

        <dl class="row">
          <dt>{{ $t("COMMON.CREATED_AT") }}</dt>
          <dd>
            {{ $timeZoneDateFormat(taxGroup.created_at) }}
          </dd>
        </dl>

        <dl class="row">
          <dt>{{ $t("COMMON.UPDATED_AT") }}</dt>
          <dd>
            {{ $timeZoneDateFormat(taxGroup.updated_at) }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tax-group-view-global",

  props: ["taxGroup"],

  data() {
    return {};
  },

  methods: {
    editTaxGroup() {
      this.$emit("onEditTaxGroup", this.taxGroup);
    },
    deleteTaxGroup() {
      this.$emit("onDeleteTaxGroup", this.taxGroup);
    },
  },
};
</script>
